import { Controller } from "@hotwired/stimulus";

// Flash dismissal (#292): the legacy body delegation for
// a[data-dismiss="flash"] and the auto-dismiss timer lived in the removed
// CoffeeScript bundle — since then the server-rendered flashes
// (layouts/application → shared/_flash_messages) could not be closed.
// Removing the element (not just fading it) matters: .flashes is absolutely
// positioned and an invisible leftover would swallow clicks.
export default class extends Controller {
  connect() {
    if (this.element.classList.contains("auto-dismissable")) {
      this.autoDismissTimer = setTimeout(() => this.fadeOut(), 27500);
    }
  }

  disconnect() {
    clearTimeout(this.autoDismissTimer);
    clearTimeout(this.removeTimer);
  }

  dismiss(event) {
    event.preventDefault();
    event.currentTarget.closest(".wrap")?.remove();
  }

  fadeOut() {
    this.element.classList.add("flash-dismiss");
    // matches the 0.5s opacity transition on .flash-dismiss
    this.removeTimer = setTimeout(() => this.element.remove(), 600);
  }
}
